export const designer = {
  name: "Mia Cho",
  role: "Fashion Designer",
  location: "New York, NY",
  tagline: "99% Flower, 1% Chaos",
  taglineLong:
    "Fun color, playful fabrics with the twist of Korean heritage.",
  about: [
    "Mia Cho is a New York based fashion designer whose work folds 한국적인 mood into a riot of color, texture and unapologetic joy.",
    "Her practice lives between the runway and the flower garden — silhouettes built from petals, ribbons, and the soft static of memory. Each piece is a quiet rebellion dressed as a party.",
    "Currently exploring the line between heirloom and hyperpop — sourcing vintage hanbok textiles, hand-dyeing in neon, and designing for the girl who keeps her grandmother in her pocket.",
  ],
  socials: {
    instagram: "https://www.instagram.com/rotterywinner_jb/",
    linkedin: "https://www.linkedin.com/in/mia-cho-b5958437b/",
    email: "chob923@newschool.edu",
  },
};

export const projects = [
  {
    id: "05",
    slug: "highschool-fantasy",
    title: "Highschool Fantasy",
    year: "2026",
    role: "Collection · Resort",
    blurb:
      "The yearbook page that never made it to print — pleats sharpened to a point, neon trim, and a uniform you'd actually wear to detention.",
    image:
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/lmrtin5q_MIA_location_may15-229.JPG",
    span: "lg:col-span-8",
    aspect: "aspect-[16/10]",
    accent: "pink",
  },
  {
    id: "04",
    slug: "liquid-sky",
    title: "Liquid Sky",
    year: "2025",
    role: "Film · Costume",
    blurb:
      "Costume direction for a short on iridescent identity — PVC clouds, chrome flowers, and a girl made of weather forecasts.",
    image:
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/8dpvphrx_Concept%202_%20398.jpg",
    span: "lg:col-span-6 lg:mt-24",
    aspect: "aspect-[4/5]",
    accent: "lime",
  },
  {
    id: "03",
    slug: "biba-queen",
    title: "Biba Queen",
    year: "2025",
    role: "Runway · Couture",
    blurb:
      "A love letter to Barbara Hulanicki served on a Seoul subway platform. Velvet, vinyl, and feathers heavy enough to cause weather.",
    image:
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/1o964o0g_Basic_%20199.jpg",
    span: "lg:col-span-6",
    aspect: "aspect-[5/6]",
    accent: "pink",
  },
  {
    id: "02",
    slug: "lost-in-museum",
    title: "Lost in Museum",
    year: "2024",
    role: "Editorial · Capsule",
    blurb:
      "A capsule wandering the wrong wing of the Met — Rococo gowns crashed by 90s K-pop sportswear and a glass-cracking lime.",
    image:
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/emfe2z9y_%E1%84%8B%E1%85%B5%E1%84%86%E1%85%B5%E1%84%8C%E1%85%B5%202024.%2012.%2010.%20%E1%84%8B%E1%85%A9%E1%84%92%E1%85%AE%207.00%20%281%29.jpg",
    span: "lg:col-span-5 lg:mt-32",
    aspect: "aspect-[3/4]",
    accent: "lime",
  },
  {
    id: "01",
    slug: "grandmother-prom-queen",
    title: "Grandmother Prom Queen",
    year: "2023",
    role: "Collection · Womenswear",
    blurb:
      "Heirloom hanbok silks reborn as a senior-prom fever dream. Tulle, satin, and the smell of my grandmother's hand cream.",
    image:
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/ganpt1k4_%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%A2%E1%84%8E%E1%85%B56666.jpg",
    span: "lg:col-span-7",
    aspect: "aspect-[4/5]",
    accent: "pink",
  },
];

export const heroImage =
  "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/42g9x09f_IMG_1972.JPG";

export const aboutPortrait =
  "https://customer-assets.emergentagent.com/job_portfolio-showcase-2301/artifacts/640xq4gp_IMG_4546.jpeg";
